import type { UpcomingTrip } from '../../../../types'
import { StatusPill } from '../../../../components/ui/StatusPill'
import { UPCOMING_TRIPS_GRID, UPCOMING_TRIPS_INSET } from './upcomingTripsLayout'

type UpcomingTripRowProps = {
  trip: UpcomingTrip
}

const displayServiceCategory = (value: string) => {
  if (!value) return ''

  const separator = value.includes('–') ? '–' : value.includes('-') ? '-' : ''

  if (!separator) return value

  const [category] = value.split(separator)
  return category.trim()
}

const formatUpcomingDate = (value: string) => {
  if (!value) return ''

  const date = new Date(`${value}T00:00:00`)

  if (Number.isNaN(date.getTime())) {
    return value
  }

  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  })
}

export const UpcomingTripRow = ({ trip }: UpcomingTripRowProps) => (
  <div
    className={`grid items-center whitespace-nowrap font-host text-[16px] font-medium leading-normal text-dash-row ${UPCOMING_TRIPS_INSET}`}
    style={{ gridTemplateColumns: UPCOMING_TRIPS_GRID }}
  >
    <span>{trip.time}</span>
    <span>{trip.bookingId}</span>
    <span>{displayServiceCategory(trip.service)}</span>
    <span>{formatUpcomingDate(trip.date)}</span>
    <span>{trip.customer}</span>
    <span className="flex justify-start">
      <StatusPill status={trip.status} />
    </span>
  </div>
)
